import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Dialog from '@material-ui/core/Dialog'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import { IconClose } from '@components/atoms/icons'
import IconButton from '@material-ui/core/IconButton'
import Embed from '@components/embed'
import useStyles from './watch-video.styles'

const WatchVideo = (props) => {
  const {
    videoID,
    headline,
  } = props

  const videoProps = { provider: 'vimeo', id: videoID, autoPlay: true }

  const styles = useStyles({ })
  const theme = useTheme()

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const [isOpen, toggleDialog] = React.useState(false)

  const handleClose = () => {
    toggleDialog(false)
  }

  return (
    <>
      <button
        onClick={() => { toggleDialog(true) }}
        aria-label={`${headline} video. plays in dialog.`}
        type="button"
        className={styles.button}
      >
        <Typography variant="body1" className={styles.buttonText}>
            Watch Video
        </Typography>
      </button>
      <Dialog
        fullScreen={isMobile}
        open={isOpen}
        onClose={() => { toggleDialog(false) }}
        aria-modal="true"
        className={styles.modalContainer}
      >
        <Box className={styles.modal} data-testid="modal">
          <div className={styles.modalHeader}>
            <IconButton
              data-testid="close-modal"
              className={styles.closeIconButton}
              title="close"
              onClick={handleClose}
            >
              <IconClose className={styles.closeIcon} />
            </IconButton>
          </div>
          <Embed {...videoProps} />
        </Box>
      </Dialog>
    </>
  )
}

WatchVideo.propTypes = {
  videoID: PropTypes.string,
  headline: PropTypes.string,
}

export default WatchVideo
